<his-plam *ngIf="!readonly">
    <p-autoComplete *ngIf="!readonly" #content [hisDdKey]="i18nIdentifier" styleClass="autocompleteWidth100"
        [required]="isMandatory()" [(ngModel)]="value" [suggestions]="suggestions"
        (completeMethod)="fillSuggestions($event)" [dropdown]="true" [size]="42" [minLength]="1" field="longtext"
        [forceSelection]="true" (ngModelChange)="onModelChange($event)">
    </p-autoComplete>
</his-plam>

<div *ngIf=" readonly && value && value.text" class="layoutBlock detailPresentationListItem">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{ i18nIdentifier | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{value.text}}</span>
    </div>
</div>
